import React from 'react';
import './CertificationServices.css';

const CertificationServices = () => {
  const services = [
    {
      icon: '📋',
      title: 'SYSTEM CERTIFICATION',
      description: 'Comprehensive system certification services'
    },
    {
      icon: '🏷️',
      title: 'PRODUCT CERTIFICATION',
      description: 'Product certification and compliance'
    },
    {
      icon: '✓',
      title: 'QUALITY CERTIFICATION',
      description: 'Quality management and assurance'
    }
  ];

  return (
    <section className="certification-services">
      <div className="services-container">
        {services.map((service, index) => (
          <div key={index} className="service-block">
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CertificationServices;

